import { useMessage } from "#internal/intl";

import { useFlag } from "@superweb/flags";

export const useTaxSystemOptions = () => {
  const message = useMessage();
  const flag = useFlag();

  const enableTaxSystemDescriptions = flag({
    id: "b5260a1a-efb9-402c-9b69-c08fc51c79c6",
    description: "Enable tax system options with descriptions",
  });

  return [
    {
      key: "USN",
      label: message({
        id: "375e3d64-58ab-40c9-9eb3-7a37683a09bb",
        context:
          "Drivers. Drivers form. Details group. Tax system option (USN)",
        default: "Simplified tax system (USN)",
      }),
      ...(enableTaxSystemDescriptions && {
        description: message({
          id: "6e7422fc-f65d-4552-9235-7fe5671fec4d",
          context:
            "Drivers. Drivers form. Details group. Tax system option (USN) description",
          default:
            "6% tax on earnings or 15% tax on the difference between earnings and expenses",
        }),
      }),
    },
    {
      key: "USNP",
      label: message({
        id: "66dd7367-4ee7-49e7-ad9f-3501e9bc9005",
        context:
          "Drivers. Drivers form. Details group. Tax system option (USNP)",
        default: "Patent tax system (with Simplified taxation)",
      }),
      ...(enableTaxSystemDescriptions && {
        description: message({
          id: "44373a8e-33f7-4b77-aed7-8877430d313d",
          context:
            "Drivers. Drivers form. Details group. Tax system option (USNP) description",
          default:
            "Simplified tax system for marketing earnings, fixed payment for other earnings",
        }),
      }),
    },
    {
      key: "AUSN",
      label: message({
        id: "50bc87ec-dbee-4384-89b2-1faf8a85d83c",
        context:
          "Drivers. Drivers form. Details group. Tax system option (AUTOUSN)",
        default: "Automated simplified tax system (AUSN)",
      }),
      ...(enableTaxSystemDescriptions && {
        description: message({
          id: "0eea5406-0ce3-4bf1-8eaf-242255f196d9",
          context:
            "Drivers. Drivers form. Details group. Tax system option (AUTOUSN) description",
          default: "8% tax, automatic calculation",
        }),
      }),
    },
    {
      key: "OSN",
      label: message({
        id: "b06ccf7b-1110-47c8-a873-1dc2b75e14e7",
        context:
          "Drivers. Drivers form. Details group. Tax system option (OSN)",
        default: "General tax system (OSN)",
      }),
      ...(enableTaxSystemDescriptions && {
        description: message({
          id: "2d845fe4-e310-4cd0-b3c5-afcded677c12",
          context:
            "Drivers. Drivers form. Details group. Tax system option (OSN) description",
          default: "35% tax (13% personal income tax + 22% VAT)",
        }),
      }),
    },
    {
      key: "OSNP",
      label: message({
        id: "9f1aa5ca-4c0a-42ed-aba2-3f9c2afec53e",
        context:
          "Drivers. Drivers form. Details group. Tax system option (OSNP)",
        default: "Patent tax system (with General taxation)",
      }),
      ...(enableTaxSystemDescriptions && {
        description: message({
          id: "202a54b8-7478-4d0a-b978-8e3a3ad80722",
          context:
            "Drivers. Drivers form. Details group. Tax system option (OSNP) description",
          default:
            "35% tax on marketing earnings, fixed payment for other earnings",
        }),
      }),
    },
  ];
};
